import React, { memo } from "react";
import {
  Box,
  TextField,
  Typography,
  Grid,
  FormControl,
  FormHelperText,
  FormControlLabel,
  RadioGroup,
  FormLabel,
  Radio,
} from "@mui/material";
import { Controller } from "react-hook-form";

const DriverDetailsForm = memo(
  ({ register, errors, control, disabled, isVehicleFinancedInput }) => {
    return (
      <Box>
        <Typography
          variant="h6"
          sx={{ fontWeight: 600, mb: 3, color: "#1f2937" }}
        >
          Driver Details
        </Typography>

        <Grid container spacing={3} sx={{ boxShadow: "none" }}>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Driver Name"
              {...register("driverName")}
              error={!!errors.driverName}
              helperText={errors.driverName}
              placeholder="Enter driver name"
              variant="outlined"
              disabled={disabled}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Mobile Number"
              {...register("mobileNumber")}
              error={!!errors.mobileNumber}
              helperText={errors.mobileNumber}
              placeholder="Enter mobile number"
              variant="outlined"
              inputProps={{ maxLength: 10 }}
              disabled={disabled}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Alternate Mobile Number"
              {...register("alternateMobileNumber")}
              error={!!errors.alternateMobileNumber}
              helperText={errors.alternateMobileNumber}
              placeholder="Enter alternate mobile number"
              variant="outlined"
              inputProps={{ maxLength: 10 }}
              disabled={disabled}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Age"
              type="number"
              {...register("age")}
              error={!!errors.age}
              helperText={errors.age}
              placeholder="Enter age"
              variant="outlined"
              inputProps={{ min: 18, max: 55 }}
              disabled={disabled}
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Residential Address"
              {...register("residentialAddress")}
              error={!!errors.residentialAddress}
              helperText={errors.residentialAddress}
              placeholder="Enter residential address"
              variant="outlined"
              multiline
              rows={3}
              disabled={disabled}
            />
          </Grid>

          {!isVehicleFinancedInput && (
            <Grid item xs={12}>
              <FormControl fullWidth error={!!errors.vehicleFinanced}>
                <Box sx={{ display: "flex", gap: 3, alignItems: "center" }}>
                  <FormLabel>Is the vehicle financed?</FormLabel>

                  <Controller
                    name="vehicleFinanced"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <RadioGroup
                        row
                        {...field}
                        value={field.value || ""}
                        onChange={(e) => field.onChange(e.target.value)}
                      >
                        <FormControlLabel
                          value="Yes"
                          control={<Radio />}
                          label="Yes"
                        />

                        <FormControlLabel
                          value="No"
                          control={<Radio />}
                          label="No"
                        />
                      </RadioGroup>
                    )}
                  />
                </Box>
                {errors.vehicleFinanced?.message && (
                  <FormHelperText>
                    {errors.vehicleFinanced?.message}
                  </FormHelperText>
                )}
              </FormControl>
            </Grid>
          )}

          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Other Information(Location)"
              {...register("otherInformation")}
              placeholder="Enter any additional information"
              helperText="Add additional details, such as location."
              variant="outlined"
              multiline
              rows={3}
              disabled={disabled}
            />
          </Grid>
        </Grid>
      </Box>
    );
  }
);

export default DriverDetailsForm;
